"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var resource_1 = require("../resource");
var comments_1 = require("./comments");
var bug = /** @class */ (function (_super) {
    tslib_1.__extends(bug, _super);
    function bug() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.route = '/bug';
        _this.comments = new comments_1.comment();
        return _this;
    }
    /**
     *
     * @param {Array<string | number> | string | number} id - id/s of bugs to retrieve.
     * @returns {Promise<Array<Bug>>} Bug(s) which were requested.
     */
    bug.prototype.get = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({
                            url: this.route,
                            params: { id: Array.isArray(id) ? id.join(',') : id }
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.bugs];
                }
            });
        });
    };
    // TODO(Reece): retrieve the newly created bug and return that instead of a ID. 
    /**
     * Create a new Bug in the Bugzilla database.
     *
     * @param {Bug} bug Bug object to be created. Required fields are defined in the Bug interface.
     * @returns {number} Return the ID of the created Bug.
     */
    bug.prototype.create = function (bug) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({
                            url: this.route,
                            method: 'POST',
                            data: bug
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.id];
                }
            });
        });
    };
    bug.prototype.update = function (ids, update) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        update.ids = Array.isArray(ids) ? ids : [ids];
                        return [4 /*yield*/, this.makeRequest({
                                url: this.route + "/update",
                                method: 'PUT',
                                data: update
                            })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    /**
     * Search the bugzilla database for relevent bugs.
     *
     * @param {searchParameters} searchParams Searchable parameters as defined by the bugzilla documentation.
     * @returns {Promise<Array<Bug>>} An array of bugs which matched the search criteria.
     */
    bug.prototype.search = function (searchParams) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({
                            url: "" + this.route,
                            params: searchParams
                        })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.bugs];
                }
            });
        });
    };
    /**
     * Get the history for a specific bug.
     *
     * @param {number | string} id The Id or Alias of a bug .
     * @param {Date} since A datetime timestamp to only show history since.
     */
    bug.prototype.getHistory = function (id, since) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({
                            url: this.route + "/" + id + "/history",
                            params: { new_since: since ? since : null }
                        })];
                    case 1:
                        result = _a.sent();
                        // undecided if i should use this module to improve the api calls. 
                        // api returns array of bugs, though only one buy can be queried at at time.
                        return [2 /*return*/, result.bugs[0]];
                }
            });
        });
    };
    bug.prototype.getFieldValues = function (field) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({ url: "/field" + this.route + "/" + field + "/values" })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.values];
                }
            });
        });
    };
    bug.prototype.getFieldValuesByProduct = function (field, product) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.makeRequest({ url: "/field" + this.route + "/" + field + "/" + product + "/values" })];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.values];
                }
            });
        });
    };
    return bug;
}(resource_1.resource));
exports.bug = bug;



//////////////////
// WEBPACK FOOTER
// ../node_modules/bzrest/lib/resources/bugs/bugs.js
// module id = 962
// module chunks = 0